import React from 'react';

export default function Orders() {
  return (
    <div className="page">
      <h1>Orders Management</h1>
      <p>Orders list coming soon...</p>
    </div>
  );
}
